import { getLocalStorage } from 'src/utils/browserStorageHandler';
import { DynamicObject } from 'src/utils/commonTypes';
import { USER_TOKEN } from 'src/utils/constants/localStorageConstants';

import { putLanguageData } from './LanguageService';

export const resetSettings = async (settingsObj: DynamicObject) => {
  if (getLocalStorage(USER_TOKEN)) {
    const promiseArray = Object.keys(settingsObj).map((key) => {
      return putLanguageData(key, settingsObj[key]);
    });
    await Promise.all(promiseArray);
  }
};
